import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { NotchedWhiteNoise } from './NotchedWhiteNoise';
import { NotchedWhiteNoiseMobile } from './NotchedWhiteNoiseMobile';
import { CookieConsent } from './CookieConsent';
import { Footer } from './Footer';
import { scrollToTop } from '../hooks/useScrollToTop';
import { useMediaQuery } from '../hooks/useMediaQuery';

export const NotchedWhiteNoisePage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [customFrequency, setCustomFrequency] = useState(1000);
  const isMobile = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    // Check for frequency in URL params
    const params = new URLSearchParams(location.search);
    const freq = params.get('freq');
    if (freq) {
      const parsedFreq = parseInt(freq);
      if (!isNaN(parsedFreq) && parsedFreq >= 20 && parsedFreq <= 20000) {
        setCustomFrequency(parsedFreq);
      }
    }
    
    // Check for frequency in navigation state
    const state = location.state as { frequency?: number } | null;
    if (state?.frequency) {
      setCustomFrequency(state.frequency);
    }
  }, [location]);


  // Use mobile-optimized version on small screens
  if (isMobile) {
    return <NotchedWhiteNoiseMobile tinnitusFrequency={customFrequency} />;
  }

  // Desktop version
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50 flex flex-col">
      {/* Simplified Header */}
      <header className="bg-white shadow-sm border-b border-purple-100">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <button 
              onClick={() => {
                navigate('/');
                setTimeout(() => scrollToTop('smooth'), 100);
              }}
              className="text-purple-600 hover:text-purple-700 font-medium transition-colors flex items-center gap-2"
            >
              ← Back to Test
            </button>
            <h1 className="text-xl font-semibold text-purple-700">TinnitusTune</h1>
            <div className="w-20"></div> {/* Spacer for center alignment */}
          </div>
        </div>
      </header>

      <div className="container mx-auto px-4 py-8 flex-grow">
        <div className="max-w-4xl mx-auto">
          {/* Notched White Noise Section */}
          <NotchedWhiteNoise tinnitusFrequency={customFrequency} />

        </div>
      </div>

      {/* Cookie Consent */}
      <CookieConsent />
      
      {/* Footer */}
      <Footer />
    </div>
  );
};